var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPdfIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 92,
    viewBox: "0 0 72 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.9996 18.3015V82.8C68.9996 87.881 64.8806 92 59.7996 92H9.2C4.11898 92 0 87.881 0 82.8V9.2C0 4.11898 4.11898 0 9.2 0H49.0743L68.9996 18.3015Z",
    fill: "#F04438"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6792_5046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.9996 18.3015H51.3743C50.1041 18.3015 49.0743 17.2718 49.0743 16.0015V0L68.9996 18.3015Z",
    fill: "#FECDCA"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2192 60.347C27.2192 61.1888 27.026 61.9616 26.6396 62.6654C26.2532 63.3554 25.6598 63.9143 24.8594 64.3421C24.059 64.7699 23.0654 64.9838 21.8786 64.9838H19.6844V70.2002H16.1447V55.6688H21.8786C23.0378 55.6688 24.0176 55.8689 24.818 56.2691C25.6184 56.6693 26.2187 57.2213 26.6189 57.9251C27.0191 58.6289 27.2192 59.4362 27.2192 60.347ZM21.6095 62.1686C22.2857 62.1686 22.7894 62.0099 23.1206 61.6925C23.4518 61.3751 23.6174 60.9266 23.6174 60.347C23.6174 59.7674 23.4518 59.3189 23.1206 59.0015C22.7894 58.6841 22.2857 58.5254 21.6095 58.5254H19.6844V62.1686H21.6095ZM34.5061 55.6688C36.0379 55.6688 37.3765 55.9724 38.5219 56.5796C39.6673 57.1868 40.5505 58.0424 41.1715 59.1464C41.8063 60.2366 42.1237 61.4993 42.1237 62.9345C42.1237 64.3559 41.8063 65.6186 41.1715 66.7226C40.5505 67.8266 39.6604 68.6822 38.5012 69.2894C37.3558 69.8966 36.0241 70.2002 34.5061 70.2002H29.062V55.6688H34.5061ZM34.2784 67.1366C35.617 67.1366 36.6589 66.7709 37.4041 66.0395C38.1493 65.3081 38.5219 64.2731 38.5219 62.9345C38.5219 61.5959 38.1493 60.554 37.4041 59.8088C36.6589 59.0636 35.617 58.691 34.2784 58.691H32.6017V67.1366H34.2784ZM53.5617 55.6688V58.5047H47.6415V61.5683H52.0713V64.3214H47.6415V70.2002H44.1018V55.6688H53.5617Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6792_5046",
    x: 42.1743,
    y: -2.3,
    width: 29.1252,
    height: 27.5018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2.3,
    dy: 2.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6792_5046"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6792_5046",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPdfIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf-icon.feae56ba9569816c00c615ef303b28c7.svg";